import clsx from "clsx";

interface SkeletonProps {
  className?: string;
  variant?: "text" | "circle" | "rect";
  lines?: number;
}

export function Skeleton({
  className = "",
  variant = "text",
  lines = 1,
}: SkeletonProps) {
  const baseClasses = "animate-pulse bg-gray-200 dark:bg-zinc-700 rounded";
  const variantClasses = {
    text: "h-4",
    circle: "h-10 w-10 rounded-full",
    rect: "h-24",
  };

  if (lines > 1) {
    return (
      <div className="space-y-2">
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className={clsx(
              baseClasses,
              variantClasses[variant],
              i === lines - 1 ? "w-3/4" : "w-full",
              className
            )}
          />
        ))}
      </div>
    );
  }

  return (
    <div
      className={clsx(
        baseClasses,
        variantClasses[variant],
        variant === "text" && "w-full",
        className
      )}
    />
  );
}

export function TableSkeleton() {
  return (
    <div className="animate-pulse">
      {/* Header */}
      <div className="bg-gray-50 dark:bg-zinc-700 px-6 py-3">
        <div className="grid grid-cols-6 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="h-4 bg-gray-200 dark:bg-zinc-700 rounded w-3/4"
            />
          ))}
        </div>
      </div>

      {/* Rows */}
      {Array.from({ length: 5 }).map((_, rowIndex) => (
        <div
          key={rowIndex}
          className="px-6 py-4 border-b border-gray-200 dark:border-zinc-700"
        >
          <div className="grid grid-cols-6 gap-4">
            {Array.from({ length: 6 }).map((_, colIndex) => (
              <div
                key={colIndex}
                className={clsx(
                  "h-4 bg-gray-200 dark:bg-zinc-700 rounded",
                  colIndex === 0 ? "w-1/2" : "w-3/4"
                )}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export function CardSkeleton({ className }: { className?: string }) {
  return (
    <div
      className={clsx(
        "bg-white dark:bg-zinc-800 dark:text-zinc-100 dark:border-zinc-700 shadow rounded-lg p-6 animate-pulse",
        className
      )}
    >
      <div className="space-y-4">
        <div className="h-6 bg-gray-200 dark:bg-zinc-700 rounded w-1/4" />
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 dark:bg-zinc-700 rounded w-full" />
          <div className="h-4 bg-gray-200 dark:bg-zinc-700 rounded w-5/6" />
          <div className="h-4 bg-gray-200 dark:bg-zinc-700 rounded w-4/6" />
          <div className="h-4 bg-gray-200 dark:bg-zinc-700 rounded w-3/6" />
          <div className="h-4 bg-gray-200 dark:bg-zinc-700 rounded w-3/6" />
        </div>
      </div>
    </div>
  );
}
